import {
  Heading,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";

type TableDataProps = {
  heading?: string;
  columns: string[];
  data: {
    feature: string;
    [key: string]: string;
  }[];
};

const ComparisonTable = (props: TableDataProps) => {
  const { heading, columns, data } = props;

  return (
    <Stack spacing={8}>
      {heading && (
        <Heading as="h2" variant={HEADING_VARIANTS.HEADLINE3} textAlign={"center"}>
          {heading}
        </Heading>
      )}
      <TableContainer>
        <Table borderColor={"rgb(237,242,247)"} borderWidth={"2px"} variant={"striped"}>
          <Thead>
            <Tr>
              <Th color="black" fontSize="24px" py={6} textTransform={"none"}>
                Feature
              </Th>
              {columns.map((column, index) => (
                <Th
                  key={index}
                  color="black"
                  fontSize="24px"
                  py={6}
                  textTransform={"none"}
                >
                  {column}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((item, index) => (
              <Tr key={index}>
                <Td fontWeight={600}>{item.feature}</Td>
                {columns.map((column, colIndex) => (
                  <Td key={colIndex}>{item[column]}</Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default ComparisonTable;
